import { z } from "zod";
export const IncidentResponseRunbookV1Schema = z
    .object({
    schemaVersion: z.literal("incident-response-runbook.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalIncidentResponseRunbook(recordedAt) {
    return IncidentResponseRunbookV1Schema.parse({
        schemaVersion: "incident-response-runbook.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=incident-response-runbook.js.map